const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'action-overrides/add-address.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/add-address.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/get-auto-suggest-suggestions-custom.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/get-auto-suggest-suggestions-custom.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/get-categories-hierarchy.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/get-categories-hierarchy.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/get-category-paths.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/get-category-paths.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/get-checkout-cart.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/get-checkout-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/get-invoice.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/get-invoice.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/get-invoices.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/get-invoices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/plp-actions/get-full-products-by-collection.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/plp-actions/get-full-products-by-collection.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/plp-actions/get-product-refiner-hierarchy.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/plp-actions/get-product-refiner-hierarchy.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'action-overrides/plp-actions/get-refiners-for-collection.action';
            binding.dataActions[actionPath] = require('partner/action-overrides/plp-actions/get-refiners-for-collection.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };